import { getNiraSlotPostProcessingOption } from "@/configuration/groups/nira/configuration";
import { getGroupConfigSubdomain } from "@/configuration/paths";
import { ConfigSubdomain } from "@/configuration/tenant-ids";
import { AppointmentType } from "@/src/models/appointment";
import { Group } from "@/src/models/group";

export enum SlotPostProcessOption {
  /** Combine adjacent same-type slots into a single longer-duration window. */
  SlotMerge = "slot_merge",
}

export function getSlotPostProcessOption(
  providerEhrId: string,
  appointmentType: AppointmentType,
  group: Group
): SlotPostProcessOption | undefined {
  switch (getGroupConfigSubdomain(group)) {
    case ConfigSubdomain.NIRA:
      return getNiraSlotPostProcessingOption(providerEhrId, appointmentType);
    default:
      return undefined;
  }
}
